module.exports = __webpack_public_path__ + "5eb97b5f528f8e3688616eedf155ec6e.png";